'use client'
import EventEmitter from 'eventemitter3';

const createFormattedInputEmitter = () => new EventEmitter();

export { createFormattedInputEmitter };
